import { useEffect } from "react";
import { X } from "lucide-react";

// Sdílený dialog: na mobilu celoobrazovkový panel (100dvh, safe-area, vlastní scroll, sticky patička), na desktopu klasické okno.
export function Modal({ title, subtitle, onClose, children, footer, testid = "modal", size = "max-w-lg" }) {
    useEffect(() => {
        const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
        document.addEventListener("keydown", onKey);
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => { document.removeEventListener("keydown", onKey); document.body.style.overflow = prev; };
    }, [onClose]);

    const onFocus = (e) => {
        const el = e.target;
        if (el && /^(INPUT|SELECT|TEXTAREA)$/.test(el.tagName)) setTimeout(() => el.scrollIntoView?.({ block: "center", behavior: "smooth" }), 250);
    };

    return (
        <div className="fixed inset-0 z-[120] bg-slate-900/50 backdrop-blur-sm flex sm:items-center sm:justify-center sm:p-4" onClick={onClose} data-testid={`${testid}-overlay`}>
            <div className={`app-modal bg-white sm:border-2 border-slate-900 w-full ${size} flex flex-col`} onClick={(e) => e.stopPropagation()} data-testid={testid} role="dialog" aria-modal="true">
                <div className="app-modal-head flex items-center justify-between px-5 sm:px-6 py-3 sm:py-4 border-b-2 border-slate-900 bg-white shrink-0">
                    <div className="min-w-0">
                        <h2 className="font-display text-lg font-bold truncate">{title}</h2>
                        {subtitle && <div className="text-xs text-slate-500 truncate">{subtitle}</div>}
                    </div>
                    <button onClick={onClose} data-testid={`${testid}-close`} aria-label="Zavřít" className="min-w-[44px] min-h-[44px] -mr-2 flex items-center justify-center text-slate-400 hover:text-slate-900">
                        <X className="w-5 h-5" />
                    </button>
                </div>
                <div className="app-modal-body flex-1 overflow-y-auto overscroll-contain px-5 sm:px-6 py-4 sm:py-5" onFocusCapture={onFocus}>
                    {children}
                </div>
                {footer && (
                    <div className="app-modal-foot shrink-0 flex gap-2 justify-end px-5 sm:px-6 py-3 sm:py-4 bg-slate-50 border-t border-slate-200">
                        {footer}
                    </div>
                )}
            </div>
        </div>
    );
}

export const modalBtnSecondary = "min-h-[44px] px-4 py-2 text-xs uppercase tracking-wider border border-slate-300 hover:bg-slate-100 rounded-sm";
export const modalBtnPrimary = "min-h-[44px] px-5 py-2 text-xs uppercase tracking-wider font-semibold bg-orange-600 hover:bg-orange-700 disabled:opacity-50 text-white rounded-sm inline-flex items-center justify-center gap-1";
